import styled from 'styled-components';

export const PersonSummaryContainer = styled.aside`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 0 8px 0;
  border-top: 1px solid ${({ theme }) => theme.tertiary.dark};
  border-bottom: 1px solid ${({ theme }) => theme.tertiary.dark};
  margin-top: 8px;
`;

export const PersonSummaryImage = styled.img`
  border-radius: 50%;
  overflow: hidden;
  width: 60px;
  height: 60px;
`;

export const PersonSummaryContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 16px 0 16px;
  font-size: 1.25rem;
  line-height: 2rem;
`;

export const PersonSummaryCTA = styled.div`
  button {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const PersonSummaryLink = styled.span`
  color: ${({ theme }) => theme.primary.main};
  text-decoration: underline;
`;
